<template>
  <v-dialog
      v-model="show"
      persistent
      width="400"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Изменить Email</span>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>

        <v-row>
          <v-col cols="12" align="center">

<!--            todo disable после отправки-->
            <v-btn
                v-if="currentUser.email"
                block
                class="my-4"
                color="green"
                @click="codeRequest"
                depressed
                outlined
            >
              Отправить код подтверждения
            </v-btn>

            <v-text-field
                v-if="currentUser.email"
                label="Код подтверждения"
                type="text"
                v-model="code"
                required
            ></v-text-field>

            <v-text-field
                label="Новый Email"
                type="email"
                v-model="email"
                required
            ></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            variant="text"
            @click="show = false"
        >
          Отменить
        </v-btn>
        <v-btn
            depressed
            outlined
            variant="text"
            @click="update"
        >
          Обновить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ChangeEmailDialog",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      email: null,
      code: null,
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.clear();
      }
    },
  },

  computed: {
    ...mapGetters('user', ['currentUser']),
    show: {
      get() {
        return this.value;
      },

      set(show) {
        this.$emit('input', show);
      }
    },

    payload() {
      return {
        code: this.code,
        email: this.email,
      }
    },
  },

  methods: {
    ...mapActions({
      sendCodeRequest: 'user/sendCodeRequest',
      changeEmail: 'user/changeEmail',
    }),

    clear() {
      this.code = null;
      this.email = null;
    },

    update() {
      this.changeEmail(this.payload)
          .then(() => {
            this.show = false;
          });
    },

    codeRequest() {
      this.sendCodeRequest('email');
    },
  },
}
</script>

<style scoped>

</style>